import React from "react";

const Loader = () => {
  return (
    <div className="flex items-center justify-center h-full w-full py-10 bg-[#f5f3ea]">
      <div className="w-14 h-14 border-4 border-[#BC3F4A] border-t-transparent rounded-full animate-spin backdrop-blur-sm bg-white/70"></div>
    </div>
  );
};

export default Loader;
